import { Injectable, InjectionToken } from '@angular/core';
import * as pino from 'pino';
import { LoggingConfig } from '../app-config';
import { EnvService } from '../env.service';
import { log } from 'console';

export const EXTERNAL_LOGGER = new InjectionToken<pino.Logger>('external_logger');


export abstract class LogginService {
    private logConfig: LoggingConfig;
    abstract get logger(): pino.Logger;

    private childLoggers: { [source: string]: pino.Logger } = {};

    public createLogger(source: string): pino.Logger
    {
        const result = this.logger.child({
            source: source
        }, { level: this.logConfig && this.logConfig.serviceOverrides && this.logConfig.serviceOverrides[source] || this.envService.logLevel });

        this.childLoggers[source] = result;

        return result;
    }

    applyLogConfig(logConfig: LoggingConfig) {
        this.logger.level = logConfig.level || this.logger.level;
        this.logConfig = logConfig;
        
        for(const key of Object.keys(logConfig.serviceOverrides)) {
            if(this.childLoggers[key] !== undefined) {
                this.childLoggers[key].level = logConfig.serviceOverrides[key];
            }
        }
    }

    constructor(private envService: EnvService) {
        this.logConfig = this.envService.logConfig;
    }
}